import http from '../../utils/httpService';
import { DATA_MANAGEMENT_ROUTE } from './constants';

/**
 *
 * @returns {*}
 */
const requestDataManagement = () => (
    http.request(DATA_MANAGEMENT_ROUTE, 'GET', null, false)
);

/**
 *
 * @param formData
 * @returns {*}
 */
const requestUpdateDataManagement = (formData) => {
    const route = DATA_MANAGEMENT_ROUTE + `/${formData.id}`;
    return http.request(route, 'PUT', formData);
};

export {
    requestDataManagement,
    requestUpdateDataManagement
};